export const PARAMETER_NAME_SAVED_FILTER_ID = 'filterId';
export const PARAMETER_NAME_START_DATE = 'startDate';
export const PARAMETER_NAME_END_DATE = 'endDate';
export const PARAMETER_NAME_STATUS_ID = 'statusID';
export const PARAMETER_NAME_STORE_GUID = 'storeGuid';
export const PARAMETER_NAME_EMBED_IMAGES = 'embedImages';
export const PARAMETER_NAME_ITEM_DEMAND_GROUP_BY = 'groupByItemSKU';
export const PARAMETER_NAME_ITEM_DEMAND_SORT_BY = 'sortField';
export const PARAMETER_NAME_SHOW_PRODUCT_SALES_BY = 'groupByItemSKU';
export const PARAMETER_NAME_SHIPMENT_GOUNT_BY_USER_GROUP_BY = 'groupByField';
export const PARAMETER_NAME_USER = 'user';
export const PARAMETER_NAME_INVENTORY_WAREHOUSE_ID = 'inventoryWarehouseId';
export const PARAMETER_NAME_GROUP_BY_PARENT_SKU = 'groupByParentSku';
export const PARAMETER_NAME_SPECIFIC_SKU = 'specificSKU';
export const PARAMETER_NAME_LABEL_PROVIDER_ID = 'providerID';
export const PARAMETER_NAME_SHOW_PRODUCT_ALIASES_BY = 'includeActive';
export const PARAMETER_NAME_SHOW_SHIPPED_ITEMS_BY = 'useItemSKU';
export const PARAMETER_NAME_SELLER_LABEL_PROVIDER_ID = 'sellerProviderID';
export const PARAMETER_NAME_SHIPPING_SERVICE_ID = 'serviceID';
export const PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY = 'postageFilter';
export const PARAMETER_NAME_SHIP_DATE = 'shipDate';
export const PARAMETER_NAME_WAREHOUSE_ID = 'warehouseID';
export const PARAMETER_NAME_HOTKEYS_REPORT_TYPE = 'reportOutputType';
export const PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_BY = 'scanActionType';
export const PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_HOTKEYS = 'shouldShowHotkeys';
export const PARAMETER_NAME_LOT = 'lot';
export const PARAMETER_NAME_INVOICE_ID = 'invoiceId';
